module.exports = __webpack_public_path__ + "static/img/comsoft-graphics-3.0403b8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/comsoft-graphics-3.png
// module id = MHAa
// module chunks = 1